'use strict';
import $ from 'jquery';
import 'slick-carousel';

export default class TabbedCustomPostsLoops {
    static init() {
        $('.section-tabbed-custom-posts-loops').each((index, el) => {
            new TabbedCustomPostsLoops($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.featuredPostsSlider(this.el.find('.tab.show').data('tab'));
        this.el.find('.toggle-tabs').on('tab-changed', (e, tab) => {
            this.featuredPostsSlider(tab);
        });
    }

    featuredPostsSlider(tab) {
        const $featured = this.el.find('[data-tab=' + tab + ']').find('.section-custom-posts-loop-featured');
        if (!$featured.hasClass('slick-initialized')) {
            $featured.slick({
                mobileFirst: true,
                dots: true,
                arrows: false,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4
                        }
                    }
                ]
            });
        } else {
            $featured.slick('setPosition');
        }
    }
}